import React from "react";
import style from "./payment.scss";

const headerColums = (props) => {
    const name = props?.t("sulu_admin.match.first.lastname");
    const hC = (
        <div
            style={{
                display: "grid",
                gridTemplateColumns: "1.3fr repeat(7, 1fr)",
                width: "79.6%",
            }}
        >
            <div>{name}</div>
            <div>Übernachtung </div>
            <div>SPAE</div>
            <div>Spesen</div>
            <div>Bahn/Flug</div>
            <div>PKW</div>
            <div>Total</div>
        </div>
    );

    return hC;
};

const footer = (noOfSelectedPlayer, minPlayers) => {
    return <></>;
};

const inputNumb = (item, displayProperty, itemClickHandler, isDisabled) => {
    return (
        <div
            className={
                displayProperty === "total"
                    ? `${style.costCurrency} ${style.disabled}`
                    : `${style.costCurrency}`
            }
        >
            <input
                className={
                    displayProperty === "total"
                        ? `${style.costInput} js-total-input`
                        : `${style.costInput} js-calculation-input-${item.id}`
                }
                type="number"
                inputMode="numeric"
                onChange={(ev) => {
                    itemClickHandler(
                        ev.currentTarget.value,
                        item.id,
                        displayProperty
                    );
                }}
                value={item[displayProperty] || ""}
                disabled={isDisabled || displayProperty === "total"}
                data-cost={displayProperty}
            ></input>
        </div>
    );
};

const columnCustom = (
    item,
    itemColumnClass,
    itemClickHandler,
    displayProperty,
    columns,
    inputNumb,
    aditionalParams = "",
    data,
    passportModal,
    index,
    positions,
    isDisabled,
    submitData
) => {
    const nonCostInputs = ["firstName", "lastName", "submit"];
    if (displayProperty === "firstName") return;
    return (
        <div
            className={itemColumnClass}
            key={displayProperty}
            style={{ padding: "0" }}
        >
            {nonCostInputs.indexOf(displayProperty) === -1 &&
                inputNumb(item, displayProperty, itemClickHandler, isDisabled)}

            {displayProperty === "lastName" &&
                item[displayProperty] + " , " + item["firstName"]}

            {displayProperty === "submit" && (
                <div
                    className={`${style.submitBtn} js-submit-btn-${item.id}`}
                    onClick={(ev) => submitData(ev.target, item.id)}
                    disabled
                >
                    Submit
                </div>
            )}
        </div>
    );
};

export { headerColums as hackHeader, inputNumb, columnCustom, footer };
